import { requestJsonWithTimeout } from '@noths/polaris-client-utils';
import getConfig from 'next/config';

const config = getConfig();

export interface CategoryAndProductCode {
  productCode: number;
  categoryId: number;
}

export interface CatalogServiceCategoryAndProduct {
  id: number;
  heading: string;
  path: string;
  product_code: number;
  product_name: string;
  product_image: string;
}

export const fetchCategoriesWithProducts = async (
  categories: CategoryAndProductCode[],
): Promise<CatalogServiceCategoryAndProduct[] | null> => {
  try {
    const mappedData = categories.map((category) => ({
      category_id: category.categoryId,
      product_code: category.productCode,
    }));
    const result = await requestJsonWithTimeout({
      apiEndpoint: config.publicRuntimeConfig.CATEGORY_CAROUSEL_ENDPOINT,
      apiPath: config.publicRuntimeConfig.CATEGORY_CAROUSEL_API_PATH,
      querystring: `pairs=${encodeURIComponent(JSON.stringify(mappedData))}`,
      method: 'GET',
      timeout: 1000,
    });

    // @ts-ignore
    return result.data;
  } catch (error) {
    console.error(`error in fetchCategoriesWithProducts: ${String(error)}`);
  }

  return null;
};
